import { FcdSegment } from './fcdsegment.model';

export class SubTrajectorySegment {
  mstFractionBegin: string;
  mstFractionEnd: string;
  fcdSegments: FcdSegment[];
  manual?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/fcd/subtrajectorysegment.model.ts